<template>
    <v-row>
        <v-col :cols="mobileColumns" :sm="(desktopColumns == 2 || desktopColumns == 2.4) ? 4 : 6" :md="(desktopColumns == 2 || desktopColumns == 2.4) ? 3 : 4" :lg="desktopColumns" v-for="(prod, j) in listProducts" :key="j">
            <v-card
                class="mx-auto"
                color="grey lighten-4"
                max-width="600"
                :disabled="emergency || !prod.available"
            >
                <div class="wrap-unavailable" v-if="!prod.available">
                    {{ $t('No disponible') }}
                </div>
                <div class="discount-flag" v-if="prod.tag_discount">
                    {{ prod.tag_discount }}
                </div>
                <v-img
                    :aspect-ratio="sizeBanner"
                    :src="prod.banner"
                    style="cursor:pointer;"
                    @click="$emit('open-details', prod.id)"
                >
                    <div class="tag-promo" v-if="prod.promo">{{ $t('Oferta') }}</div>
                </v-img>
                <v-card-text
                    class="pt-4 pb-0"
                    style="position: relative;"
                >
                    <h4 class="font-weight-light mb-0 text-sm-h5 text-subtitle-1 mb-2" :style="{'color':titleCardColor}">
                        {{ (prod.store_show_name && prod.store_show_name!='null') ? prod.store_show_name : prod.name }}
                    </h4>
                    <v-list-item three-line class="pa-0" v-if="prod.description!='' && prod.description!='null' && prod.description!=null">
                        <v-list-item-content class="py-0">
                            <v-list-item-subtitle :style="{'color':contentColor, 'fontSize':'16px', '-webkit-line-clamp': 4}">
                                <!-- <div v-html="prod.description"></div> -->
                                {{ prod.description.replace(/<[^>]+>/g, '') }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
                <v-card-actions v-if="prod.price">
                    <div v-if="prod.stock">
                        {{ $t('Sólo') }} {{ prod.stock }} {{ $t('en stock') }}
                    </div>
                    <v-spacer></v-spacer>
                    <div class="mb-2 text-right" v-if="prod.special_price" :style="{'color':priceColor}">
                        <span class="font-weight-light text-decoration-line-through grey--text">
                            {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                        </span>
                        <span class="title">
                            {{ money }} {{ (prod.special_price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                        </span>
                    </div>
                    <div class="mb-2 text-right" v-else :style="{'color':priceColor}">
                        <span class="title">
                            {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                        </span>
                    </div>
                </v-card-actions>
                <v-card-actions v-else>
                    <div class="mb-2">&nbsp;</div>
                </v-card-actions>
                <v-card-actions v-if="typeStore!='real_estate'" :class="!funCart ? 'pa-0' : ''">
                    <v-spacer></v-spacer>
                    <template v-if="funCart">
                        <v-btn
                            :color="btnColor"
                            :style="{color: textbtnColor, fontSize: (mobileColumns == 6 && $vuetify.breakpoint.xsOnly) ? '9px' : ''}"
                            @click="$emit('open-details', prod.id)"
                            v-if="prod.type == 'product'"
                            :small="(desktopColumns == 2 || desktopColumns == 2.4) || (mobileColumns == 6 && $vuetify.breakpoint.smAndDown)"
                        >{{ $t('Agregar al carrito') }}</v-btn>
                    </template>
                    <v-btn
                        :color="btnColor"
                        :style="{color: textbtnColor}"
                        @click="$emit('open-details', prod.id)"
                        v-if="prod.type == 'service'"
                    >{{ $t('Reservar') }}</v-btn>
                </v-card-actions>
                <v-card-actions v-if="typeStore=='real_estate'">
                    <v-spacer></v-spacer>
                    <v-btn
                        :color="btnColor"
                        :style="{color: textbtnColor, fontSize: (mobileColumns == 6 && $vuetify.breakpoint.xsOnly) ? '9px' : ''}"
                        @click="$emit('open-details', prod.id)"
                        v-if="prod.type == 'product'"
                        :small="(desktopColumns == 2 || desktopColumns == 2.4) || (mobileColumns == 6 && $vuetify.breakpoint.smAndDown)"
                    >{{ $t('Agendar') }}</v-btn>
                    <v-btn
                        :color="btnColor"
                        :style="{color: textbtnColor}"
                         @click="$emit('open-details', prod.id)"
                        v-if="prod.type == 'service'"
                    >{{ $t('Reservar') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="12" v-if="to < total">
            <div class="text-center py-4">
                <v-btn
                    :color="btnColor"
                    :style="{color: textbtnColor}"
                    x-large
                    :loading="loading"
                    @click="loadMore"
                >{{ $t('Cargar más') }}</v-btn>
            </div>
        </v-col>
    </v-row>
</template>
<script>
export default {
    data() {
        return {
            listProducts: [],
            loading: false,
            page: 1,
            total: null,
            to: null,
        };
    },
    props: ['cat',
        'emergency',
        'sizeBanner',
        'titleCardColor',
        'contentColor',
        'priceColor',
        'money',
        'btnColor',
        'textbtnColor',
        'mobileColumns',
        'desktopColumns',
        'funCart',
        'typeStore'
    ],
    mounted() {
        this.getProducts()
    },
    methods: {
        loadMore() {
            this.page += 1
            this.loading = true
            this.getProducts()
        },
        async getProducts() {
            axios.get(`/list-products/${this.cat}?page=${this.page}`)
            .then((response) => {
                // console.log(response);
                this.listProducts.push(...response.data.data)
                this.to = response.data.to
                this.total = response.data.total

                this.loading = false
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }

                this.loading = false
            })
        }
    },
}
</script>
